import { Box, Icon, IconButton, makeStyles, Switch, TextField, Typography, useTheme } from '@material-ui/core'
import { AddOutlined, CancelOutlined } from '@material-ui/icons'
import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { Fragment } from 'react'

import { MainButton } from '../..'
import { SubTitle, Title } from './Headers'

const useStyles = makeStyles((theme) => ({
	row: {
		width: '100%',
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		'& .MuiTextField-root, .MuiAutocomplete-root, .MuiFilledInput-root': {
			// width: 270,
			minWidth: 270
		},
		'& .MuiSvgIcon-root': {
			color: '#3B0275',
			fill: '#3B0275'
		}
	},
	input: {
		marginBottom: theme.spacing(2),
		width: '32%'
	},
	switchBox: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		backgroundColor: '#F3F3F3',
		borderRadius: 6,
		height: 50,
		width: '32%',
		paddingLeft: 16,
		paddingRight: 16,
		marginBottom: 12,
		marginTop: 12
	},
	switchRoot: {
		width: 51,
		height: 31,
		padding: 0
	},
	switchBase: {
		padding: 0,
		margin: 2,
		'&.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
			backgroundColor: '#6B4AD6',
			opacity: 1
		},
		'&$checked': {
			transform: 'translateX(20px)',
			color: theme.palette.common.white,
			'& + $track': {
				backgroundColor: '#6B4AD6',
				opacity: 1
			},
			'& .far::before': {
				color: '#6B4AD6',
				opacity: 1
			},
			'& .far': {
				color: '#6B4AD6'
			}
		},
		'&$focusVisible $thumb': {
			color: '#6B4AD6'
			//border: "6px solid #fff",
		}
	},
	thumb: {
		width: 27,
		height: 27,
		background: '#F3F3F3',
		border: '1px solid #E5E5E5',
		borderRadius: '50%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& .far': {
			color: '#A2A1A4',
			fontSize: '13px',
			lineHeight: '15px'
		}
	},
	track: {
		borderRadius: 100,
		padding: 2,
		backgroundColor: '#D0CFD2',
		opacity: 1,
		transition: theme.transitions.create(['background-color'])
	}
}))

export const ListWithAddButtonMultiple = ({
	title,
	subtitle,
	list = [], // list of elements with _id
	label1,
	label2,
	label3,
	key1,
	key2,
	key3,
	labeltoogle,
	toogleKey,
	showHelperTextKey1 = true,
	showHelperTextKey2 = true,
	showHelperTextKey3 = true,
	onChange,
	onAdd,
	onDelete,
	disabled = false,
	maxCharacters = 100,
	addButtonLabel = 'Add',
	additionalMessage = ''
}) => {
	const classes = useStyles()
	const theme = useTheme()

	return (
		<Fragment>
			{title && <Title label={title} />}
			{subtitle && <SubTitle label={subtitle} />}
			<Box>
				{!disabled &&
					list
						// .sort(sortByKey((a) => a.order))
						.map(
							(
								{ [key1]: element1, [key2]: element2, [key3]: element3, [toogleKey]: toogleValue },
								index
							) => (
								<Box>
									<Box key={'ListWithAddButton' + index} className={classes.row}>
										<TextField
											className={clsx([classes.input])}
											style={{ width: '30%' }}
											label={label1}
											variant="filled"
											required
											value={element1}
											onChange={(e, v) => {
												e.preventDefault()
												list[index][key1] = e.target.value
												if (onChange) onChange(list)
											}}
											helperText={
												showHelperTextKey1
													? `${element1.length || 0} / ${maxCharacters} Max Characters`
													: undefined
											}
											inputProps={{ maxLength: maxCharacters }}
										/>
										<TextField
											className={clsx([classes.input])}
											style={{ width: '30%' }}
											label={label2}
											variant="filled"
											required
											value={element2}
											onChange={(e, v) => {
												e.preventDefault()
												list[index][key2] = e.target.value
												if (onChange) onChange(list)
											}}
											helperText={
												showHelperTextKey2
													? `${element2.length || 0} / ${maxCharacters} Max Characters`
													: undefined
											}
											inputProps={{ maxLength: maxCharacters }}
										/>
										<TextField
											className={clsx([classes.input])}
											style={{ width: '30%' }}
											label={label3}
											variant="filled"
											required
											value={element3}
											onChange={(e, v) => {
												e.preventDefault()
												list[index][key3] = e.target.value
												if (onChange) onChange(list)
											}}
											helperText={
												showHelperTextKey3
													? `${element3.length || 0} / ${maxCharacters} Max Characters`
													: undefined
											}
											inputProps={{ maxLength: maxCharacters }}
										/>
										<Box style={{ width: '5%' }}>
											<IconButton
												style={{
													color: '#777679'
												}}
												onClick={() => {
													list.splice(index, 1)
													if (onDelete) onDelete(list)
												}}>
												<CancelOutlined style={{ fill: theme.palette.error.main }} />
											</IconButton>
										</Box>
									</Box>
									{!!labeltoogle && !!toogleKey && (
										<Box className={classes.row}>
											<div
												style={{
													marginBottom: 56,
													width: '100%'
													// display: addOn.limited ? 'none' : ''
												}}>
												<div className={classes.switchBox}>
													<Typography
														variant="body2"
														style={{
															fontWeight: '600',
															color: '#1A1A35',
															fontSize: 16
														}}>
														Auto-Expanded Section
													</Typography>
													<Switch
														checked={toogleValue}
														// disabled={addOn._id ? true : false}
														onChange={() => {
															list[index][toogleKey] = !toogleValue
															if (onChange) onChange(list)
														}}
														name="toogle"
														icon={
															<div className={classes.thumb}>
																<Icon className="far fa-times" />
															</div>
														}
														checkedIcon={
															<div className={classes.thumb}>
																<Icon className="far fa-check" />
															</div>
														}
														classes={{
															root: classes.switchRoot,
															switchBase: classes.switchBase,
															thumb: classes.thumb,
															track: classes.track,
															checked: classes.checked
														}}
													/>
												</div>
											</div>
										</Box>
									)}
								</Box>
							)
						)}
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<MainButton
						label={addButtonLabel}
						disabled={disabled}
						onClick={() => {
							const perks = list || []
							perks.push({
								[key1]: '',
								[key2]: '',
								[key3]: perks.length + 1
							})
							if (onAdd) onAdd(perks)
						}}
						startIcon={<AddOutlined style={{ fill: theme.palette.secondary.main }} />}
					/>
					{additionalMessage && !!list.length ? <Typography>{additionalMessage}</Typography> : null}
				</Box>
			</Box>
		</Fragment>
	)
}
